<template>
	<div class="purchase-fail wrapper">
		<div class="murk">
			<div class="title-header">
				<h1>
					{{ $t('checkout.title') }}
					<accountInfoGroup></accountInfoGroup>
					<div class="clearfix"></div>
				</h1>
			</div>
			<div v-if="!inFraudReview" id="failContainer" class="order-detail-wrapper">
				<h2 class="heading-normal text-center">
					{{ $t('checkout.purchase-failed') }}
					<small>
						{{ setFailMessage }}
						<br />
						<span v-if="errorCode">{{ $t('checkout.error-code', { errorCode }) }}</span>
					</small>

					<i18n v-if="queryErrorCode === '000-400-0006'" path="checkout.error-code-support-link" tag="small">
						<a
							v-t="`${queryErrorCode}`"
							place="errorCodeSupportLink"
							href="https://playersupport.nexon.com/hc/en-us/articles/360001139883"
							target="_blank"
						></a>
					</i18n>

					<i18n v-if="queryErrorCode === '000-400-0010'" path="checkout.learn-about-karmakoin" tag="small">
						<strong v-t="'www.karmakoin.com'" place="karmakoinLink"></strong>
					</i18n>
				</h2>
				<hr />
				<div v-if="orderNumber" class="detail-information">
					<div class="item">
						<span>{{ $t('checkout.order-number') }}</span>
						<span class="order-number">{{ orderNumber }}</span>
					</div>
				</div>
				<div class="detail-information additional-description">
					<i18n v-if="region === 'tw'" path="checkout.questions-comments" tag="p">
						<a
							v-t="'checkout.support-link-text'"
							place="supportLink"
							href="https://tw.nexon.com/help/zh"
							target="_blank"
							@click="onSupportClick"
						></a>
					</i18n>
					<i18n
						v-else-if="queryErrorCode === '000-400-0010'"
						path="checkout.questions-comments-purchase-limit"
						tag="p"
					>
						<strong
							v-t="'http://m.nexon.com/cc/report/guest/write?client_id=MjEzMjE5MjcwNQ'"
							place="supportLink"
							@click="onSupportClick"
						></strong>
					</i18n>
					<i18n v-else path="checkout.questions-comments" tag="p">
						<a
							v-t="'checkout.support-link-text'"
							place="supportLink"
							href="mailto:BillingPP@nexon.net"
							@click="onSupportClick"
						></a>
					</i18n>
				</div>
			</div>
			<div v-else id="inReviewContainer" class="order-detail-wrapper">
				<h3 v-if="queryErrorCode === '000-400-0007'" class="heading-normal text-center">
					{{ $t('checkout.currently-under-review') }}
				</h3>
				<h3 v-if="queryErrorCode === '000-400-0008'" class="heading-normal text-center">
					{{ $t('checkout.still-under-review') }}
				</h3>
				<div class="detail-information additional-description">
					<p>{{ $t('checkout.under-review-details') }}</p>
				</div>
			</div>
			<div class="col-xs-6 col-xs-offset-3">
				<buttonType
					class
					:btn-primary="true"
					:label="setButtonText"
					:button-click="continueToGame"
				></buttonType>
			</div>
		</div>
	</div>
</template>

<script>
import buttonType from '@arena/toolkit/src/components/common/button';
import accountInfoGroup from './common/account-info-group';
import config from '../config/environment-config';

export default {
	name: 'CheckoutFailed',
	orderNumber: 'reviewPurchase',
	components: {
		accountInfoGroup,
		buttonType,
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('checkout.title')}`,
		};
	},
	props: {
		orderNumber: {
			type: String,
			default: null,
		},
		returnURL: {
			type: String,
			default: null,
		},
		anotherPayment: {
			type: String,
			default: null,
		},
		currency: {
			type: String,
			default: null,
		},
		errorCode: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			appType: this.$store.state.appType,
		};
	},
	computed: {
		setButtonText() {
			if (this.inFraudReview) {
				return this.$t('checkout.return-to-payment-methods');
			}
			if (this.appType === 'web') {
				return this.$t('checkout.try-again');
			}
			return this.$t('checkout.close-window');
		},
		setErrorCode() {
			return this.$t(this.errorCode);
		},
		setFailMessage() {
			if (this.$route.query.message) {
				return decodeURI(this.$route.query.message);
			} else if (this.$route.query.error_code) {
				const code = decodeURI(this.$route.query.error_code),
					messageKey = `error.form.${code}`;
				if (this.$t(messageKey) !== messageKey) {
					return `${this.$t(messageKey)} (${code})`;
				}
			}
			return this.$t('checkout.unable-to-complete-purchase');
		},
		serviceType() {
			return this.$route.query.service_type;
		},
		inFraudReview() {
			return ['000-400-0007', '000-400-0008'].includes(this.queryErrorCode);
		},
		queryErrorCode() {
			return decodeURI(this.$route.query.error_code);
		},
	},
	mounted() {
		this.$a2s.view('error_imp', {
			name: 'error_code',
			value: this.errorCode,
			objectTag: 'purchase_error',
		});

		const mainSpinner = document.getElementById('main-spinner');
		if (!mainSpinner.classList.contains('hide')) {
			mainSpinner.className += ' hide';
		}
	},
	methods: {
		continueToGame() {
			this.$a2s.click('error_close');
			if (this.inFraudReview) {
				if (this.serviceType && this.serviceType === 'direct') {
					// dirct to "AnotherPayment"
					window.location = this.anotherPayment;
				} else {
					// eslint-disable-next-line prettier/prettier
					window.location = `${config[process.env.VUE_APP_ENV][environment.region].wallet}?app_type=${
						this.$store.state.appType
					}`;
				}
			} else if (this.returnURL) {
				this.goto(this.returnURL);
			} else {
				window.close();
			}
		},
		onSupportClick() {
			this.$a2s.click('error_support');
		},
	},
};
</script>

<style lang="less" scoped>
.purchase-fail {
	.order-detail-wrapper {
		margin-bottom: 1em;
	}
}
</style>
